@import "~/styles/v1/_variables.scss";

.ResourceTypeSelectorDisplay {
  .Selector {
    background-color: transparent;
    border: 0;
    box-shadow: none;
    padding: 0;

    &.Selector_S {
      color: $system_eggplant-lightest;
      font-size: 11px;
      font-weight: 700;
      line-height: 1;
      text-transform: uppercase;
    }

    &.Selector_L {
      font-size: 18px;
      font-weight: 600;

      .ResourceType {
        border-bottom: 2px solid $system_eggplant-lightest;

        &:hover {
          border-bottom: 2px solid $system_eggplant-base;
        }
      }
    }
  }
}
